<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="living-here">
<h1>Living Here</h1>
<p style="text-align: center;">fleeting thought exiled to flight the swooping bird’s illusion crashed against the glass</p><br/>
<p style="text-align: center;">so the unread will rewrite the tricks to sound out loving crashed against the glass</p><br/>
<p style="text-align: center;">of the floating world’s peep show where no airborne dive is spared the joke (i don’t get</p><br/>
<p style="text-align: center;">but laugh at — lowing to know healing remains in repair) yesterdays fly yet</p><br/>
<p style="text-align: center;">the poor thing left a house gift its wingspan’s ghostly imprint ‘This is not your home’</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?0641858f